import { INode } from "@/types/INode";
import Bus from "@/lib/Bus"; const bus: Bus = new Bus().getBus(); 

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window { Clip: Clip; }
}

export default class Clip {
  _Clip: any;
  public nodes:any={}

  getClip() {
    if (!window.Clip) {
      this._Clip = document.createElement("div");
      window.Clip = this;
      return window.Clip;
    } else {
      return window.Clip;
    }
  }

  add(node:INode) {

    if (node._id && node.type) {
      this.nodes[node.type]=node;
      alert('Dodano do notatnika: '+node.idn)
      bus.fire("clipboard_changed",{})
    } else {
      alert('Zapisz najpierw zmiany!')
    }
  }

  del(node:INode) {
    if (node.type) delete(this.nodes[node.type]);
    bus.fire("clipboard_changed",{})
  }

}
